import React from 'react';

import {
    SessionTimeoutModalWrapper,
    SessionExpired
} from '../../../components';
import { UseSessionTimeoutHook } from '../hooks';
import { SessionExpiryTimer } from './session-expiry-timer';
import {
    LoaderDots, TeacherAdminIcon
} from '@components';

export type SessionTimeoutModalViewProps = UseSessionTimeoutHook;

export const IdleSessionTimeoutView = ({
    isLoading,
    onExtendSession,
    onExpiredCountdown,
    onSignIn,
    durationSecs,
    isCountdownVisible
}: SessionTimeoutModalViewProps) => {
    return (
        <SessionTimeoutModalWrapper>
            {isLoading ?
                <LoaderDots />
                :
                <IdleSessionPrompt
                    isCountdownVisible={isCountdownVisible}
                    durationSecs={durationSecs}
                    onSignIn={onSignIn}
                    onExtendSession={onExtendSession}
                    onExpiredCountdown={onExpiredCountdown}
                />}
        </SessionTimeoutModalWrapper>
    );
};

export type SessionPromptProps = Omit<SessionTimeoutModalViewProps, 'isLoading'>;

export function IdleSessionPrompt ({
    durationSecs,
    isCountdownVisible,
    onSignIn,
    onExpiredCountdown,
    onExtendSession
}: SessionPromptProps) {
    return (
        <>
            <TeacherAdminIcon
                icon={'warning'}
                width={90}
            />

            {isCountdownVisible ?
                <SessionExpiryTimer
                    onExtendSession={onExtendSession}
                    onExpiredCountdown={onExpiredCountdown}
                    durationSecs={durationSecs}
                /> :
                <SessionExpired
                    onSignIn={onSignIn}
                />
            }
        </>
    );
}
